import { toast } from "react-toastify";

export const toastSuccess = (message) => {
  toast.success(message, {
    position: toast.POSITION.TOP_CENTER,
    draggable: false,
    closeOnClick: false,
    autoClose: 5000,
    hideProgressBar: true
  });
};

export const toastError = (message) => {
  toast.error(message, {
    position: toast.POSITION.TOP_CENTER,
    draggable: false,
    closeOnClick: false,
    autoClose: 5000,
    hideProgressBar: true
  });
};

export const toastStickyError = (message) => toast.error(message, {
  position: toast.POSITION.TOP_CENTER,
  draggable: false,
  closeOnClick: false,
  autoClose: false,
  hideProgressBar: true
});

export const toastStickyWarning = (message) => toast.warning(message, {
  position: toast.POSITION.TOP_CENTER,
  draggable: false,
  closeOnClick: false,
  autoClose: false,
  hideProgressBar: true
});

export const dismissToast = (toastId) => {
  toast.dismiss(toastId);
};

export const EVENT_REMOVE_ERROR =
  "We couldn't remove this event — a system error occurred and our team has been notified. Please contact support if you need it removed.";

export const errorText = (e, fallback = "Something went wrong.") => {
  const status = e?.response?.status;
  const data = e?.response?.data;
  if (!data) return fallback;

  if (Array.isArray(data)) return data.length > 0 ? data.join(", ") : fallback;

  if (status && status >= 500) return fallback;

  if (typeof data === "string") {
    const trimmed = data.trim();
    if (!trimmed || trimmed.startsWith("<")) return fallback;
    return trimmed;
  }
  if (data.errors) {
    if (Array.isArray(data.errors)) return data.errors.length > 0 ? data.errors.join(", ") : fallback;
    if (typeof data.errors === "object") {
      const flat = Object.values(data.errors).flat();
      return flat.length > 0 ? flat.join(", ") : fallback;
    }
    return String(data.errors);
  }
  if (data.message) return String(data.message);
  if (data.error) return String(data.error);

  return fallback;
};

export const actionErrorText = (e, fallback = "Something went wrong.") => (
  e?.response?.status >= 500 ? fallback : errorText(e, fallback)
);

export const toastInfo = (message) => {
  toast.info(message, {
    position: toast.POSITION.TOP_CENTER,
    draggable: false,
    closeOnClick: false,
    autoClose: 8000,
    hideProgressBar: true
  });
};
